<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="buttonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="reprintReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="accountPayableReportBySupplierExportAll()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="dateFilterList"
                label="Date Filter"
                v-model="queryParams.dateFilter"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="Po No"
                label="Po No"
                type="text"
                v-model="queryParams.poNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="supplierCode"
                label="Supplier Code"
                type="text"
                v-model="queryParams.supplierCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="supplierName"
                label="SupplierName"
                type="text"
                v-model="queryParams.supplierName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="warehouseList"
                v-model="queryParams.warehouseIds"
                label="Select Warehouse"
                item-text="name"
                item-value="id"
                multiple
                clearable
                small-chips
                :disabled="
                  user.roleName == 'PROCUREMENT_MANAGER' && user.warehouseId
                "
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="activeCurrencyList"
                v-model="queryParams.currencyId"
                label="Currency"
                item-text="code"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Purchase Amount :</span>
              <v-chip>
                <span>{{ totalCreditAmount | decFormat(6) }}</span>
              </v-chip>
              <span>Total Purchase Amount(MMK) :</span>
              <v-chip>
                <span>{{ totalCreditAmountMMK | decFormat(6) }}</span> </v-chip
              ><br />
              <span>Total Credit Paid Amount :</span>
              <v-chip>
                <span>{{ totalCreditPaidAmount | decFormat(6) }}</span>
              </v-chip>
              <span>Total Credit Paid Amount(MMK) :</span>
              <v-chip>
                <span>{{
                  totalCreditPaidAmountMMK | decFormat(6)
                }}</span> </v-chip
              ><br />
              <span>Total Remaining Amount :</span>
              <v-chip>
                <span>{{
                  (totalCreditAmount - totalCreditPaidAmount) | decFormat(6)
                }}</span>
              </v-chip>
              <span>Total Remaining Amount(MMK) :</span>
              <v-chip>
                <span>{{
                  (totalCreditAmountMMK - totalCreditPaidAmountMMK)
                    | decFormat(6)
                }}</span> </v-chip
              ><br />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="accountPayableDetailList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.status }}</td>
              <td>
                {{ props.item.issueDateInMilliSecond | formatMsDate }}
              </td>
              <td>
                {{ props.item.dueDateInMilliSecond | formatMsDate }}
              </td>
              <td>{{ props.item.supplierCode }}</td>
              <td>{{ props.item.supplierName }}</td>
              <td>{{ props.item.currencyCode }}</td>
              <td>{{ props.item.exchangeRate }}</td>
              <td>{{ props.item.poNo }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td style="text-align: right">
                {{ props.item.creditAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.creditPaidAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.remainingAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.creditAmountMMK | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.creditPaidAmountMMK | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.remainingAmountMMK | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Account Payable Report By Supplier
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Date From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Reported Date: [{{ currentDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Issue Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Due Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Supplier Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Supplier Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Currency
              </th>
              <th style="border: 1px solid black; text-align: center">
                Exchange Rate
              </th>
              <th style="border: 1px solid black; text-align: center">PO No</th>
              <th style="border: 1px solid black; text-align: center">
                Warehouse
              </th>
              <th style="border: 1px solid black; text-align: center">
                Status
              </th>
              <th style="border: 1px solid black; text-align: center">
                Purchase Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Credit Paid Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Remaining Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Purchase Amount MMK
              </th>
              <th style="border: 1px solid black; text-align: center">
                Credit Paid Amount MMK
              </th>
              <th style="border: 1px solid black; text-align: center">
                Remaining Amount MMK
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in allAccountPayableReportList" :key="i">
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueDateInMilliSecond | formatMsDate }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.dueDateInMilliSecond | formatMsDate }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.supplierCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.supplierName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.currencyCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.exchangeRate }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.poNo }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.warehouseName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.status }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditPaidAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.remainingAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditAmountMMK | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditPaidAmountMMK | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.remainingAmountMMK | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  text-align: right;
                  font-weight: bold;
                "
                colspan="9"
              >
                Grand Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  text-align: right;
                  font-weight: bold;
                "
              >
                {{ totalCreditAmount | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  text-align: right;
                  font-weight: bold;
                "
              >
                {{ totalCreditPaidAmount | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  text-align: right;
                  font-weight: bold;
                "
              >
                {{ (totalCreditAmount - totalCreditPaidAmount) | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  text-align: right;
                  font-weight: bold;
                "
              >
                {{ totalCreditAmountMMK | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  text-align: right;
                  font-weight: bold;
                "
              >
                {{ totalCreditPaidAmountMMK | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  text-align: right;
                  font-weight: bold;
                "
              >
                {{
                  (totalCreditAmountMMK - totalCreditPaidAmountMMK)
                    | decFormat(6)
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { accountPayableService } from "../../services/account-payable-service";
import { currencyService } from "../../services/currency-service";
import { warehouseService } from "../../services/warehouse-service";

export default {
  name: "AccountPayableReportBySupplier",
  components: {},

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showSupplierListDialog: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Account Payable Report By Supplier",
        disabled: true,
      },
    ],
    headers: [
      { text: "Status", align: "left", sortable: false },
      { text: "Issue Date", align: "left", sortable: false },
      { text: "Due Date", align: "left", sortable: false },
      { text: "Supplier No", align: "left", sortable: false },
      { text: "Supplier Name", align: "left", sortable: false },
      { text: "Currency", align: "left", sortable: false },
      { text: "Exchange Rate", align: "left", sortable: false },
      { text: "PO No", align: "left", sortable: false },
      { text: "Warehouse", align: "left", sortable: false },
      { text: "Purchase Amount", align: "left", sortable: false },
      { text: "Credit Paid Amount", align: "left", sortable: false },
      { text: "Remaining Amount", align: "left", sortable: false },
      { text: "Purchase Amount MMK", align: "left", sortable: false },
      { text: "Credit Paid Amount MMK", align: "left", sortable: false },
      { text: "Remaining Amount MMK", align: "left", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      dateFilter: "ISSUE_DATE",
      warehouseIds: [],
      supplierName: "",
      supplierCode: "",
      currencyId: "",
    },
    currentDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    accountPayableDetailList: [],
    allAccountPayableReportList: [],
    totalCreditAmount: 0,
    totalCreditPaidAmount: 0,
    totalCreditAmountMMK: 0,
    totalCreditPaidAmountMMK: 0,
    clonequeryParams: new Object(),
    activeCurrencyList: [],
    warehouseList: [],
    dateFilterList: [
      { label: "Issue Date", value: "ISSUE_DATE" },
      { label: "Due Date", value: "DUE_DATE" },
    ],
    statusList: [
      { label: "ALL", value: "" },
      { label: "FINISH", value: "FINISH" },
      { label: "CREDIT", value: "CREDIT" },
    ],
  }),
  watch: {
    pagination: {
      handler() {
        this.getAccountPayableReportBySupplier();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.roleName == "PROCUREMENT_MANAGER") {
      this.queryParams.warehouseIds = [this.user.warehouseId];
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.supplierName) {
      this.queryParams.supplierName = this.$route.query.supplierName;
    }
    if (this.$route.query.supplierCode) {
      this.queryParams.supplierCode = this.$route.query.supplierCode;
    }
    if (this.$route.query.currencyId) {
      this.queryParams.currencyId = this.$route.query.currencyId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.onSearch();
    this.getActiveCurrency();
    this.getActiveWarehouse();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "account-payable-report-by-supplier",
        query: this.queryParams,
      });
      this.getAccountPayableReportBySupplier();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },

    getAccountPayableReportBySupplier() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      accountPayableService
        .getAccountPayableReportBySupplier(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountPayableDetailList = res.data.accountPayableDetailList;
            this.totalCreditAmount = res.data.totalCreditAmount;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalCreditAmountMMK = res.data.totalCreditAmountMMK;
            this.totalCreditPaidAmountMMK = res.data.totalCreditPaidAmountMMK;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    reprintReport(divName) {
      this.buttonLoading = true;
      accountPayableService
        .getAllAccountPayableReportBySupplierPrint(this.clonequeryParams)
        .then((res) => {
          this.allAccountPayableReportList = res.data.accountPayableDetailList;
          this.totalCreditAmount = res.data.totalCreditAmount;
          this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    getActiveWarehouse() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    accountPayableReportBySupplierExportAll() {
      this.buttonLoading = true;
      accountPayableService
        .getAccountPayableReportBySupplierExcelExport(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    getActiveCurrency() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.activeCurrencyList = res.data;
          let findAll = { id: "", code: "---All---" };
          this.activeCurrencyList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
